module.exports = __webpack_public_path__ + "static/img/seven.9e9c052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/seven.png
// module id = yIEt
// module chunks = 0